import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Verónica M.',
    role: 'Terapeuta Ocupacional',
    location: 'Buenos Aires',
    text: 'Antes de tener el Kit llegaba al consultorio improvisando. Ahora entro sabiendo exactamente qué le voy a dar a cada paciente. Me cambió la semana entera.',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
  }, {
    name: 'Daniela R.',
    role: 'Psicóloga',
    location: 'Córdoba',
    text: 'Lo que más me sorprendió fue la Guía de Derivación. Tuve una situación difícil con una familia que minimizaba los cambios del paciente y los scripts me dieron las palabras exactas que necesitaba.',
    avatar: 'https://randomuser.me/api/portraits/women/65.jpg'
  }, {
    name: 'Luciana F.',
    role: 'Psicopedagoga',
    location: 'Rosario',
    text: 'El Planificador de Evolución fue un cambio enorme. Ahora tengo registros reales para mostrarle a la familia y para fundamentar mis decisiones clínicas. Me siento mucho más segura profesionalmente.',
    avatar: 'https://randomuser.me/api/portraits/women/32.jpg'
  }, {
    name: 'Mariana S.',
    role: 'Fonoaudióloga',
    location: 'Mendoza',
    text: 'Compré el Kit un viernes a la noche. El lunes lo estaba usando con tres pacientes distintos. No tuve que adaptar nada. Todo estaba pensado para el consultorio real.',
    avatar: 'https://randomuser.me/api/portraits/women/28.jpg'
  }, {
    name: 'María José L.',
    role: 'Psicóloga',
    location: 'La Plata',
    text: 'El módulo de adolescentes me permitió ampliar mi consultorio. Ahora atiendo desde los 12 hasta los 90 años con el mismo nivel de profesionalismo. Es un cambio de juego total.',
    avatar: 'https://randomuser.me/api/portraits/women/50.jpg'
  }];
  return <section className="py-16 sm:py-24 bg-white" data-id="element-242">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-244">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-245">
            LO QUE DICEN LOS PROFESIONALES QUE YA LO USAN
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12" data-id="element-246">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-247">
                <div className="flex gap-1 mb-4" data-id="element-248">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-249" />)}
                </div>

                <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-250">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center gap-3" data-id="element-251">
                  <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full" data-id="element-252" />
                  <div data-id="element-253">
                    <p className="font-bold text-gray-900" data-id="element-254">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-255">
                      {testimonial.role} · {testimonial.location}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}